export default function safeAssign (defaults, received) {
  return Object.keys(defaults).reduce((acc, k) => {
    acc[k] = received[k] != null ? received[k] : defaults[k]
    return acc
  }, {})
}
